export default {
  title: {
    history: '批量上传历史',
    uploader: '批量上传'
  },
  label: {
    fileName: '文件名',
    startTime: '创建时间',
    finishTime: '完成时间',
    status: '状态',
    browserFiles: '点击浏览文件',
    job: '职位',
    source: '追踪代码名称',
    code: '追踪代码明细 ',
    comment: '评论',
    tag: {
      smart: '智能标签',
      manual: '候选人标签'
    },
    notification: '发送提醒邮件',
    onlyTalentPool: '只添加到人才库',
    candidateName: '求职者姓名',
    email: '邮箱',
    phone: '电话',
    result: '结果',
    duplicateTitle: '潜在重复候选人',
    hrOpenQuestion: '招聘人员筛选',
    failReason: '失败原因'
  },
  btn: {
    backJobList: '查看职位列表',
    backApplicantList: '求职者列表',
    backTalentPoll: '人才库',
    backUniversal: '候选人申请',
    viewHistory: '查看上传历史',
    openUploader: '批量添加求职者',
    startUpload: '开始上传',
    viewCandidate: '查看求职者',
    import: '导入',
    viewDuplicateCandidate: '查看'
  },
  message: {
    dropTip: '拖拽简历到此处',
    or: '或',
    uploadTip: [
      '你可以一次性上传500封简历，单个文件不超过10MB，总大小不超过500MB',
      "支持以下格式：'pdf', 'doc', 'docx, 'shtml', 'html', 'png', 'jpg', 'jpeg', 'bmp' 和 'zip'"
    ],
    noSelectedFile: '还没有选择任何文件',
    uploadingTip: '文件正在上传中，请勿关闭该页面',
    uploadedTip: '文件上传已结束，你可以安全的关闭该页面。简历的处理稍后将会自动开始',
    noUploadingFile: '暂时没有正在上传的文件',
    leavePageTip: '确定离开该页面？仍然存在正在上传的文件！',
    fileCountLimit: '单次上传只能添加{count}个文件',
    fileSizeLimit: '单次文件大小不能超过{size}MB',
    uploadFinished: '上传完成',
    sourceTips: '不是所有的用户都能新建追踪代码名称，如果你无法看到你想用的追踪代码名称也不能新建，请联系你的菁客客户经理或者邮件联系service@ajinga.com',
    sourcePlaceholder: '例如Job Fair或者Hiring Campaign等，建议用英文',
    codeTips: '不是所有的用户都能新建追踪代码明细，如果你无法看到你想用的追踪代码明细也不能新建，请联系你的菁客客户经理或者邮件联系service@ajinga.com',
    codePlaceholder: '例如招聘会日期，活动名称等，建议用英文',
    noCandidate: '至少选择一位候选人',
    importSuccess: '导入成功',
    uploadFailed: '上传失败'
  },
  containerTitle: {
    uploadHistory: '上传历史',
    selectedFiles: '已选择的文件',
    uploadStatus: '文件正在上传中，请勿关闭该页面...',
    parseSuccess: '解析成功',
    parseFail: '解析失败'
  },
  taskStatus: {
    FAILED: '失败',
    FINISHED: '成功',
    APPLICATION_EXISTED: '重复',
    WAITING: '处理中',
    UPLOADING: '上传中',
    NO_CONTACT_INFO: '候选人邮箱和手机号均未填写',
    EXISTED_HR_ACCOUNT: '该账号为公司用户 ',
    TALENT_EXISTED: '重复'
  }
}
